export default __webpack_public_path__ + "thumb-down.png";